import React from "react";
import { FaPlus, FaPlay } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AIPrograms = () => {
  const navigate = useNavigate();

  return (
    // Main container with consistent theme and padding
    <div className="bg-slate-100 min-h-screen p-8 lg:p-12 font-sans">
      <div className="max-w-6xl mx-auto">
        {/* Header Section */}
        <header>
          <h1 className="text-4xl font-bold text-slate-800">AI Programs</h1>
          <p className="mt-3 text-slate-600 max-w-4xl leading-relaxed">
            Build, orchestrate and deploy AI Programs — sequences of prompts, tools,
            and flows that automate tasks or run multi-step interactions. Programs
            let you combine assistants, vector searches, and external actions into
            repeatable pipelines for common workflows.
            <br />
            To create a new program click the{" "}
            <span className="font-semibold text-slate-700">+ New Program</span> button below.
            Ensure you have your{" "}
            <a
              href="/dashboard/openai-settings"
              className="font-semibold text-blue-500 hover:text-cyan-400 transition-colors"
            >
              OpenAI key
            </a>{" "}
            and any Vector Stores configured.
          </p>
        </header>

        {/* Main Content Card */}
        <div className="mt-16 bg-white rounded-xl shadow-sm p-8 relative">
          {/* "+ New Program" Button */}
          <button
            onClick={() => navigate("/dashboard")}
            className="absolute top-0 left-8 -translate-y-1/2 flex items-center gap-2 bg-blue-500 text-white font-semibold px-5 py-2 rounded-lg shadow-md hover:bg-blue-600 transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          >
            <FaPlus className="text-lg" />
            New Program
          </button>

          {/* Call-to-Action Section */}
          <div className="flex flex-col items-center justify-center text-center py-24">
            <FaPlay className="text-blue-500 text-6xl mb-6" />
            <h2 className="text-4xl font-medium text-slate-800 max-w-2xl leading-tight">
              <span className="font-bold text-blue-500">Create your first AI Program</span> — combine
              assistants, searches and actions into automated pipelines
            </h2>
            <p className="mt-6 text-slate-700 text-lg">
              Programs can run automatically, be triggered by events, or be started manually.
              They are ideal for report generation, data enrichment, tutoring flows, and more.
            </p>

            {/* Quick action buttons */}
            <div className="mt-8 flex flex-wrap gap-3 justify-center">
              <button
                onClick={() => navigate("/dashboard/openai-settings")}
                className="flex items-center gap-3 bg-blue-500 text-white font-bold px-6 py-3 rounded-lg shadow-lg hover:bg-blue-600 hover:shadow-cyan-400/30 transform hover:-translate-y-1 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Get OpenAI key
                <span aria-hidden="true">&rarr;</span>
              </button>

              <button
                onClick={() => navigate("/dashboard/vector-stores")}
                className="flex items-center gap-3 bg-white text-slate-800 font-semibold px-6 py-3 rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition"
              >
                Configure Vector Store
              </button>
            </div>

            {/* Short helper note */}
            <p className="mt-6 text-sm text-slate-500 max-w-xl">
              Tip: Programs can reference Assistants and Vector Stores. Make sure those are created
              first to allow richer program behaviors.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
};

export default AIPrograms;
